/**
 * Created by JIA on 2022/1/19.
 */

import _ from "lodash";
import * as Helper from "../../../../utils/Helper";
import htmlparser from "htmlparser2-without-node-native";
import AppConfig from "../../../../config/AppConfig";
import { t } from "../../../../i18n";
import { AzureEnums, i18nKey, IsTheERCase, reviewServiceTypeEnum as serviceTypeEnum } from "../SpeechCommonHelper";
import Constants from "../../../../config/Constants";

//region [XunFei Result Process]

const XunFeiEnums = {
    EXCEPT_INFO: {
        INITIAL_SILENCE_TIMEOUT: 28673, //except_info=28673时，16进制为0x7001，表示引擎判断该语音为无语音或音量小类型
        NO_SOUND_2: 28675, //except_info=28675, 测试获得,文档无.
        NO_MATCH: 28676, //except_info=28676时，16进制为0x7004，表示引擎判断该语音为乱说类型
        RATIO_LOW: 28680, //except_info=28680时，16进制为0x7008，表示引擎判断该语音为信噪比低类型
        CLIPPING_AUDIO: 28690, //except_info=28690时，16进制为0x7012，表示引擎判断该语音为截幅类型
        NO_SOUND: 28689, //except_info=28689时，16进制为0x7011，表示引擎判断没有音频输入，请检测音频或录音设备是否正常
    },
    IS_REJECTED: {
        //true：被拒，表明引擎检测到乱读，分值不能作为参考,false：正常
        REJECTED: "true",
        PASS: "false",
    },
    REC_NODE_TYPE: {
        PAPER: "paper", //paper(试卷内容）,sil(非试卷内容）
        SIL: "sil",
    },
    IS_YUN: {
        INITIAL: 0, //声母
        FINAL: 1, //韵母
    },
    DP_MESSAGE: {
        NONE: 0,
        OMISSION: 16, //漏读
        INSERTION: 32, //增读
        REGRESSION: 64, //回读
        MISPRONUNCIATION: 128, //替换
    },
    // 当DP_MESSAGE不为0时，PERR_MSG可能出现与DP_MESSAGE值保持一致的情况
    P_ERR_MESSAGE: {
        INITIAL_WRONG: 1, //当IS_YUN=0时：PERR_MSG有两种状态：0 声母正确 ；1 声母错误
        INITIAL_RIGHT: 0,
        FINAL_TONE_RIGHT: 0, //当IS_YUN=1时：PERR_MSG有四种状态：0韵母和调型均正确 1韵母错误；2调型错误；3韵母和调型均错误；
        FINAL_WRONG: 1, //当IS_YUN=1时：PERR_MSG有四种状态：0韵母和调型均正确 1韵母错误；2调型错误；3韵母和调型均错误；
        TONE_WRONG: 2, //声韵调型错
        FINAL_TONE_WRONG: 3, //韵母和调型均错误
    },
    //返回检错结果的置信度（共1,2,3三个数值，1最好，3最差。如果出现为0的情况可以不考虑）
    P_ERR_LEVEL_MSG: {
        BEST: 1,
        GOOD: 2,
        OK: 3,
        BAD: 0,
    },
};

//拼音需是字典中正确的拼音，调型在0-9之间取值，其中0/5/6/7/8/9均代表轻声。
//为没有调形的添加5
const normalizePinyinForXunFei = (pinyinz) => {
    if (_.isString(pinyinz) && pinyinz.length > 0) {
        //讯飞不认识ü的拼音, 替换成v
        const zPinyin = _.replace(pinyinz, "ü", "v");
        const lastChar = pinyinz[zPinyin.length - 1];
        if (/[\d]/gi.test(lastChar)) {
            return zPinyin;
        } else {
            return `${zPinyin}5`;
        }
    }

    return "";
};

/**
 * 尝试将传入的文本和拼音组装成讯飞支持的注音题目格式
 *  https://www.xfyun.cn/doc/Ise/IseAPI.html#%E8%AF%95%E9%A2%98%E6%A0%BC%E5%BC%8F%E8%AF%B4%E6%98%8E
 * <customizer: interphonic>
 * 今天天气怎么样
 * jin1|tian1|tian1|qi4|zen3|me5|yang4
 * @param interObj
 * @param nativeSetReferenceText
 */
const handleTextForXunFei = (interObj, nativeSetReferenceText) => {
    const { syllableArray, referenceText } = interObj;
    if (interObj.lang === Constants.SPEECH_LANG.en) {
        let finalText = "[content]\n";
        finalText += referenceText;
        nativeSetReferenceText(finalText);
    } else {
        let referenceSyllableArray = syllableArray;
        let referenceSyllableArrayValid = referenceSyllableArray && referenceText && _.isArray(referenceSyllableArray) && referenceSyllableArray.length === referenceText.length;

        //比如 AA 制 这种不是全中文的,我们就不标音标了
        if (!_.every(Array.from(referenceText), (item) => Helper.isChineseCharacters(item))) {
            referenceSyllableArrayValid = false;
        }
        if (referenceSyllableArrayValid) {
            let finalText = "<customizer: interphonic>\n";
            let punctuationArr = [];
            //获取参考答案的拼音
            let newReferenceSyllableArray = [];
            let ERIndexArray = []; //保存 儿化音case 儿的index
            const zReferenceText = _.map(referenceText, (s, index) => {
                if (Helper.isPunctuation(s)) {
                    punctuationArr.push({
                        letter: s,
                        index: index,
                    });
                    return "";
                }
                if (referenceSyllableArrayValid) {
                    newReferenceSyllableArray.push(referenceSyllableArray[index]);

                    if (index > 0) {
                        const lastChar = referenceText[index - 1];
                        if (!Helper.isPunctuation(lastChar)) {
                            const nowSyllableArrLength = newReferenceSyllableArray.length;
                            const isTheERCase = IsTheERCase(referenceText[index - 1], s, newReferenceSyllableArray[nowSyllableArrLength - 2], newReferenceSyllableArray[nowSyllableArrLength - 1]);
                            if (isTheERCase) {
                                //儿化音case, 回退本字和上一个字
                                newReferenceSyllableArray[nowSyllableArrLength - 2] = newReferenceSyllableArray[nowSyllableArrLength - 2].slice(0, -1);
                                newReferenceSyllableArray[nowSyllableArrLength - 1] = "er5";
                                ERIndexArray.push(nowSyllableArrLength - 1);
                            }
                        }
                    }
                }
                return s;
            }).join("");
            finalText += zReferenceText + "\n";
            const map = newReferenceSyllableArray.map((s) => normalizePinyinForXunFei(s));
            finalText += _.join(map, "|");
            //console.log(finalText);
            nativeSetReferenceText(finalText);
        }
    }
};

const domUtils = htmlparser.DomUtils;
const findChildrenEleInParsedDom = (dom, tagName, forFirstElement = true) => {
    if (dom) {
        let target = null;
        if (_.isArray(dom)) {
            target = dom;
        } else if (domUtils.isTag(dom) && dom.children && _.isArray(dom.children)) {
            target = dom.children;
        }

        if (target) {
            return forFirstElement ? _.find(target, (x) => x && x.type === "tag" && x.name === tagName) : _.filter(target, (x) => x && x.type === "tag" && x.name === tagName);
        }
    }

    return null;
};

const convertDP_MessageToAzureErrorInfo = (dp_message) => {
    switch (_.toNumber(dp_message)) {
        case XunFeiEnums.DP_MESSAGE.OMISSION:
            return AzureEnums.WordErrorType.Omission;
        case XunFeiEnums.DP_MESSAGE.INSERTION:
        case XunFeiEnums.DP_MESSAGE.REGRESSION:
            return AzureEnums.WordErrorType.Insertion;
        case XunFeiEnums.DP_MESSAGE.MISPRONUNCIATION:
            return AzureEnums.WordErrorType.Mispronunciation;
        case XunFeiEnums.DP_MESSAGE.NONE:
        default:
            return AzureEnums.WordErrorType.None;
    }
};

const splitXunFeiPinYinYun = (wordPinYin, pinyinArr) => {
    let result = {
        wordPinYin: wordPinYin,
        mPinyin: "",
        yunPinyin: "",
    };
    let mPinyin = null;
    let yunPinyin = null;
    _.each(pinyinArr, (sItem, index) => {
        if (sItem.isYun) {
            yunPinyin = sItem;
        } else {
            mPinyin = sItem;
        }
    });

    if (mPinyin && yunPinyin) {
        if (_.includes(wordPinYin, mPinyin.content)) {
            result.mPinyin = mPinyin.content;
            result.yunPinyin = _.includes(wordPinYin, mPinyin.content, "");
        }
    }

    return result;
};

const processXunfeiDom = (internalInfoObj, parseError, dom) => {
    // xml example <?xml version="1.0" encoding="UTF-8"?>
    //   <xml_result>
    //       <read_sentence lan="cn" type="study" version="7,0,0,1024">
    //           <rec_paper>
    //               <read_sentence accuracy_score="0.000000" beg_pos="0" content="你好吗。" emotion_score="0.000000" end_pos="289" except_info="0" fluency_score="93.122978" integrity_score="100.000000" is_rejected="false" phone_score="100.000000" time_len="289" tone_score="100.000000" total_score="93.752548">
    //                   <sentence beg_pos="0" content="你好吗" end_pos="289" fluency_score="0.000000" phone_score="100.000000" time_len="289" tone_score="100.000000" total_score="95.753189">
    //                       <word beg_pos="0" content="你" end_pos="172" symbol="ni2" time_len="172">
    //                           <syll beg_pos="0" content="sil" dp_message="0" end_pos="137" rec_node_type="sil" time_len="137">
    //                               <phone beg_pos="0" content="sil" dp_message="0" end_pos="137" rec_node_type="sil" time_len="137"></phone>
    //                           </syll>
    //                           <syll beg_pos="137" content="你" dp_message="0" end_pos="172" rec_node_type="paper" symbol="ni2" time_len="35">
    //                               <phone beg_pos="137" content="n" dp_message="0" end_pos="152" is_yun="0" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="15"></phone>
    //                               <phone beg_pos="152" content="i" dp_message="0" end_pos="172" is_yun="1" mono_tone="TONE2" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="20"></phone>
    //                           </syll>
    //                       </word>
    //                       <word beg_pos="172" content="好" end_pos="206" symbol="hao3" time_len="34">
    //                           <syll beg_pos="172" content="好" dp_message="0" end_pos="206" rec_node_type="paper" symbol="hao3" time_len="34">
    //                               <phone beg_pos="172" content="h" dp_message="0" end_pos="182" is_yun="0" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="10"></phone>
    //                               <phone beg_pos="182" content="ao" dp_message="0" end_pos="206" is_yun="1" mono_tone="TONE3" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="24"></phone>
    //                           </syll>
    //                       </word>
    //                       <word beg_pos="206" content="吗" end_pos="289" symbol="ma5" time_len="83">
    //                           <syll beg_pos="206" content="吗" dp_message="0" end_pos="253" rec_node_type="paper" symbol="ma0" time_len="47">
    //                               <phone beg_pos="206" content="m" dp_message="0" end_pos="216" is_yun="0" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="10"></phone>
    //                               <phone beg_pos="216" content="a" dp_message="0" end_pos="253" is_yun="1" mono_tone="TONE0" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="37"></phone>
    //                           </syll>
    //                           <syll beg_pos="253" content="sil" dp_message="0" end_pos="289" rec_node_type="sil" time_len="36">
    //                               <phone beg_pos="253" content="sil" end_pos="289" time_len="36"></phone>
    //                           </syll>
    //                       </word>
    //                   </sentence>
    //               </read_sentence>
    //           </rec_paper>
    //       </read_sentence>
    //   </xml_result>
    let returnObj = {
        shouldResolve: false,
        rejectMessage: "",
        result: {},
    };
    let internalResult = {
        passed: false,
        resultWordArray: [],
        referenceTextWordArray: [],
        pronScore: 0,
        accuracyScore: 0,
        fluencyScore: 0,
        completionScore: 0,
        wordResultArray: [],
        notPassedWordIndexDic: {}, // the key is index, the value is word item
        rawResult: null,
        parsedRootEle: null,
    };
    if (!parseError && dom) {
        //find root in the parse result, should be the  <read_sentence ... part in the <rec_paper
        let read_sentence = null;
        //<xml_result>
        //     <read_sentence lan="cn" type="study" version="7,0,0,1024">
        //          <rec_paper>
        //              <read_sentence
        let xml_result = findChildrenEleInParsedDom(dom, "xml_result");
        if (internalInfoObj.lang === Constants.SPEECH_LANG.en) {
            //   <xml_result>
            //   <read_sentence lan="en" type="study" version="7.0.0.1020">
            //   <rec_paper>
            //   <read_chapter accuracy_score="3.576277" beg_pos="0" content="hello" end_pos="194" except_info="0" fluency_score="4.449500" integrity_score="5.000000" is_rejected="false" reject_type="0" score_pattern="loose" standard_score="3.707429" total_score="3.851359" word_count="1">
            //   <sentence accuracy_score="3.576277" beg_pos="0" content="hello" end_pos="194" fluency_score="4.199500" index="0" standard_score="3.707429" total_score="3.776359" word_count="1">
            //   <word beg_pos="90" content="hello" dp_message="0" end_pos="146" global_index="0" index="0"  pitch_beg="100" pitch_end="138" property="0" total_score="4.507634"
            let r_read_sentence = findChildrenEleInParsedDom(xml_result, "read_sentence");
            let rec_paper = findChildrenEleInParsedDom(r_read_sentence, "rec_paper");
            let read_chapter = findChildrenEleInParsedDom(rec_paper, "read_chapter");
            read_sentence = findChildrenEleInParsedDom(read_chapter, "sentence");
            if (read_sentence) {
                let sentenceAttr = read_sentence.attribs;
                let chapterAttr = read_chapter.attribs;
                internalResult.rawResult = domUtils.getOuterHTML(xml_result);
                internalResult.is_rejected = _.toLower(sentenceAttr.is_rejected) === XunFeiEnums.IS_REJECTED.REJECTED;

                internalResult.resultWordArray = sentenceAttr.content.split(""); //should we compare this?
                internalResult.referenceTextWordArray = internalInfoObj.referenceText.split("");

                //seems en score max score is 5
                internalResult.pronScore = _.toNumber(sentenceAttr.standard_score) * 20;
                internalResult.accuracyScore = _.toNumber(sentenceAttr.accuracy_score) * 20;
                internalResult.fluencyScore = _.toNumber(chapterAttr.fluency_score) * 20;
                internalResult.completionScore = _.toNumber(chapterAttr.integrity_score) * 20;
                internalResult.toneScore = _.toNumber(sentenceAttr.tone_score) * 20;
                internalResult.totalScore = _.toNumber(sentenceAttr.total_score) * 20;

                let passedWordCount = 0;
                // go inner for word
                //<word beg_pos="90" content="hello" dp_message="0" end_pos="146" global_index="0" index="0" pitch_beg="100" pitch_end="138" property="0" total_score="4.507634">
                //     <syll beg_pos="90" content="hh eh" end_pos="106" serr_msg="0" syll_accent="0" syll_score="4.330363">
                //         <phone beg_pos="90" content="hh" dp_message="0" end_pos="103" gwpp="-0.065712"></phone>
                //         <phone beg_pos="103" content="eh" dp_message="0" end_pos="106" gwpp="-2.464908"></phone>
                //     </syll>
                //     <syll beg_pos="106" content="l ow" end_pos="146" serr_msg="0" syll_accent="1" syll_score="4.996514">
                //         <phone beg_pos="106" content="l" dp_message="0" end_pos="116" gwpp="-0.006518"></phone>
                //         <phone beg_pos="116" content="ow" dp_message="0" end_pos="146" gwpp="-0.003933"></phone>
                //     </syll>
                // </word>
                let words = findChildrenEleInParsedDom(read_sentence, "word", false);
                if (AppConfig.SPEECH_RECOGNIZE_XUN_FEI_RESULT_TYPE === 1 && words) {
                     //ignore for now
                    _.each(words, (item, index) => {
                        const wordAttr = item.attribs;
                        //ignore the sil word
                        if (wordAttr.content !== "sil") {
                            let flag = false;

                            let sylls = findChildrenEleInParsedDom(item, "syll", false);
                            flag = !_.some(sylls, (p) => p && p.attribs && _.toNumber(p.attribs.serr_msg) !== XunFeiEnums.DP_MESSAGE.NONE); //passed
                            let syllablesResult = [];
                            _.each(sylls, (sItem, sindex) => {
                                const syllAttr = sItem.attribs;
                                syllablesResult.push({
                                    content: syllAttr.content,
                                    isYun: syllAttr.syll_accent === "1",
                                    dpMessage: syllAttr.serr_msg,
                                    syll_score: syllAttr.syll_score,
                                    pErrMsg: syllAttr.serr_msg,
                                });
                            });


                            const wordResultObj = {
                                word: wordAttr.content,
                                pronScore: 0,
                                accuracyScore: wordAttr.total_score * 20,
                                errorType: wordAttr ? convertDP_MessageToAzureErrorInfo(wordAttr.dp_message) : AzureEnums.WordErrorType.None,
                                syllables: syllablesResult,
                            };

                            internalResult.wordResultArray.push(_.cloneDeep(wordResultObj));

                            if (flag) {
                                passedWordCount += 1;
                            } else {
                                internalResult.notPassedWordIndexDic[_.toString(index)] = _.cloneDeep(wordResultObj);
                            }
                        }
                    });
                }

                //we will check the final pass word count and see if you are passed, total_score seems not so high as azure
                internalResult.passed = !internalResult.is_rejected && _.toNumber(sentenceAttr.total_score) > 70;
                internalResult.passedWordCount = passedWordCount;
                internalResult.wholeWordCount = internalResult.wordResultArray.length;

                //	except_info=28673时，16进制为0x7001，表示引擎判断该语音为无语音或音量小类型
                // except_info=28676时，16进制为0x7004，表示引擎判断该语音为乱说类型
                // except_info=28680时，16进制为0x7008，表示引擎判断该语音为信噪比低类型
                // except_info=28690时，16进制为0x7012，表示引擎判断该语音为截幅类型
                // except_info=28689时，16进制为0x7011，表示引擎判断没有音频输入，请检测音频或录音设备是否正常
                //评测结果中会给出 is_rejected 字段，当字段值为 true 时，说明此时是用户乱说导致的拒识，开发者可根据这个字段判断此次用户是否为乱说。 如果引擎报出乱说，那么就可以认为评分已经不可信。可根据except_info属性值初步判断乱读的原因
                if (internalResult.is_rejected && sentenceAttr.except_info) {
                    switch (_.toNumber(sentenceAttr.except_info)) {
                        case XunFeiEnums.EXCEPT_INFO.CLIPPING_AUDIO:
                        case XunFeiEnums.EXCEPT_INFO.RATIO_LOW:
                        case XunFeiEnums.EXCEPT_INFO.NO_SOUND:
                        case XunFeiEnums.EXCEPT_INFO.NO_SOUND_2:
                        case XunFeiEnums.EXCEPT_INFO.INITIAL_SILENCE_TIMEOUT:
                            //returnObj.shouldResolve = false;
                            returnObj.rejectMessage = t(`${i18nKey}:PleaseSpeak`);
                            break;
                        case XunFeiEnums.EXCEPT_INFO.NO_MATCH:
                            //returnObj.shouldResolve = false;
                            returnObj.rejectMessage = t(`${i18nKey}:NotChinese`);
                            break;
                        default:
                            returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
                            //returnObj.shouldResolve = false;
                            break;
                    }
                    //如果用户被rejected. 我们返回0分
                    internalResult.passedWordCount = 0;
                    internalResult.pronScore = 0;
                    internalResult.accuracyScore = 0;
                    internalResult.fluencyScore = 0;
                    internalResult.completionScore = 0;
                    internalResult.toneScore = 0;
                    internalResult.totalScore = 0;
                    returnObj.result = internalResult;
                    returnObj.shouldResolve = true;
                } else {
                    returnObj.result = internalResult;
                    returnObj.shouldResolve = true;
                }
            } else {
                returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
            }
        } else {
            let r_read_sentence = findChildrenEleInParsedDom(xml_result, "read_sentence");
            let rec_paper = findChildrenEleInParsedDom(r_read_sentence, "rec_paper");
            read_sentence = findChildrenEleInParsedDom(rec_paper, "read_sentence");

            if (read_sentence) {
                let sentenceAttr = read_sentence.attribs;
                internalResult.rawResult = domUtils.getOuterHTML(xml_result);
                internalResult.is_rejected = _.toLower(sentenceAttr.is_rejected) === XunFeiEnums.IS_REJECTED.REJECTED;

                internalResult.resultWordArray = sentenceAttr.content.split(""); //should we compare this?
                internalResult.referenceTextWordArray = internalInfoObj.referenceText.split("");

                internalResult.pronScore = _.toNumber(sentenceAttr.phone_score);
                internalResult.accuracyScore = _.toNumber(sentenceAttr.total_score); //accuracy_score always 0, use total_score instead
                internalResult.fluencyScore = _.toNumber(sentenceAttr.fluency_score);
                internalResult.completionScore = _.toNumber(sentenceAttr.integrity_score);
                internalResult.toneScore = _.toNumber(sentenceAttr.tone_score);
                internalResult.totalScore = _.toNumber(sentenceAttr.total_score);

                let passedWordCount = 0;
                //go for inner word
                //                   <sentence beg_pos="0" content="你好吗" end_pos="289" fluency_score="0.000000" phone_score="100.000000" time_len="289" tone_score="100.000000" total_score="95.753189">
                //                       <word beg_pos="0" content="你" end_pos="172" symbol="ni2" time_len="172">
                //                           <syll beg_pos="0" content="sil" dp_message="0" end_pos="137" rec_node_type="sil" time_len="137">
                //                               <phone beg_pos="0" content="sil" dp_message="0" end_pos="137" rec_node_type="sil" time_len="137"></phone>
                //                           </syll>
                //                           <syll beg_pos="137" content="你" dp_message="0" end_pos="172" rec_node_type="paper" symbol="ni2" time_len="35">
                //                               <phone beg_pos="137" content="n" dp_message="0" end_pos="152" is_yun="0" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="15"></phone>
                //                               <phone beg_pos="152" content="i" dp_message="0" end_pos="172" is_yun="1" mono_tone="TONE2" perr_level_msg="1" perr_msg="0" rec_node_type="paper" time_len="20"></phone>
                //                           </syll>
                //                       </word>
                let sentence = findChildrenEleInParsedDom(read_sentence, "sentence");
                let words = findChildrenEleInParsedDom(sentence, "word", false);
                if (AppConfig.SPEECH_RECOGNIZE_XUN_FEI_RESULT_TYPE === 1 && words) {
                    _.each(words, (item, index) => {
                        let flag = false;

                        let sylls = findChildrenEleInParsedDom(item, "syll", false);
                        //only use rec_node_type="paper" , should only have one for every word
                        let realSylls = _.filter(sylls, (s) => s.attribs && s.attribs.rec_node_type === XunFeiEnums.REC_NODE_TYPE.PAPER);
                        flag = !_.some(realSylls, (p) => p && p.attribs && _.toNumber(p.attribs.dp_message) !== XunFeiEnums.DP_MESSAGE.NONE); //passed
                        let syllablesResult = [];
                        _.each(realSylls, (sItem, sindex) => {
                            let phones = findChildrenEleInParsedDom(sItem, "phone", false);
                            _.each(phones, (pItem, pIndex) => {
                                let phoneFlag = _.some(pItem, (p) => p && p.attribs && p.attribs.perr_msg !== 0); //passed
                                //dp_message：0正常；16漏读；32增读；64回读；128替换（当dp_message不为0时，perr_msg可能出现与dp_message值保持一致的情况）；
                                // mono_tone：调型
                                // perr_level_msg：返回检错结果的置信度（共1,2,3三个数值，1最好，3最差。如果出现为0的情况可以不考虑）
                                // is_yun：0声母，1韵母：
                                // 当is_yun=0时：perr_msg有两种状态：0 声母正确 ；1 声母错误
                                // 当is_yun=1时：perr_msg有四种状态：0韵母和调型均正确1韵母错误；2调型错误；3韵母和调型均错误；
                                const pAttrs = pItem.attribs;
                                const isYun = pAttrs.is_yun && pAttrs.is_yun === "1";
                                if (pAttrs.dp_message !== "0") {
                                    phoneFlag = false;
                                } else {
                                    if (isYun) {
                                        phoneFlag = pAttrs.perr_msg === "0";
                                    } else {
                                        phoneFlag = pAttrs.perr_msg === "0";
                                    }
                                }
                                syllablesResult.push({
                                    content: pAttrs.content,
                                    isYun: pAttrs.is_yun,
                                    dpMessage: pAttrs.dp_message,
                                    flag: phoneFlag,
                                    monoTone: pAttrs.is_yun ? pAttrs.mono_tone : "",
                                    pErrMsg: pAttrs.perr_msg,
                                });
                            });
                        });

                        const firstSyll = _.first(realSylls);
                        const wordAttr = item.attribs;
                        let splitPinYinYun = splitXunFeiPinYinYun(wordAttr.symbol, syllablesResult);
                        const wordResultObj = {
                            word: wordAttr.content,
                            pronScore: 0,
                            accuracyScore: 0,
                            errorType: firstSyll && firstSyll.attribs ? convertDP_MessageToAzureErrorInfo(firstSyll.attribs.dp_message) : AzureEnums.WordErrorType.None,
                            phonemes: wordAttr.symbol, //just copy here
                            syllables: syllablesResult,
                            splitPinYinYun: splitPinYinYun,
                        };

                        internalResult.wordResultArray.push(_.cloneDeep(wordResultObj));

                        if (flag) {
                            passedWordCount += 1;
                        } else {
                            internalResult.notPassedWordIndexDic[_.toString(index)] = _.cloneDeep(wordResultObj);
                        }
                    });
                }

                //we will check the final pass word count and see if you are passed, total_score seems not so high as azure
                internalResult.passed = !internalResult.is_rejected && _.toNumber(sentenceAttr.total_score) > 70 && passedWordCount === internalResult.wordResultArray.length;
                internalResult.passedWordCount = passedWordCount;
                internalResult.wholeWordCount = internalResult.wordResultArray.length;

                //	except_info=28673时，16进制为0x7001，表示引擎判断该语音为无语音或音量小类型
                // except_info=28676时，16进制为0x7004，表示引擎判断该语音为乱说类型
                // except_info=28680时，16进制为0x7008，表示引擎判断该语音为信噪比低类型
                // except_info=28690时，16进制为0x7012，表示引擎判断该语音为截幅类型
                // except_info=28689时，16进制为0x7011，表示引擎判断没有音频输入，请检测音频或录音设备是否正常
                //评测结果中会给出 is_rejected 字段，当字段值为 true 时，说明此时是用户乱说导致的拒识，开发者可根据这个字段判断此次用户是否为乱说。 如果引擎报出乱说，那么就可以认为评分已经不可信。可根据except_info属性值初步判断乱读的原因
                if (internalResult.is_rejected && sentenceAttr.except_info) {
                    switch (_.toNumber(sentenceAttr.except_info)) {
                        case XunFeiEnums.EXCEPT_INFO.CLIPPING_AUDIO:
                        case XunFeiEnums.EXCEPT_INFO.RATIO_LOW:
                        case XunFeiEnums.EXCEPT_INFO.NO_SOUND:
                        case XunFeiEnums.EXCEPT_INFO.NO_SOUND_2:
                        case XunFeiEnums.EXCEPT_INFO.INITIAL_SILENCE_TIMEOUT:
                            //returnObj.shouldResolve = false;
                            returnObj.rejectMessage = t(`${i18nKey}:PleaseSpeak`);
                            break;
                        case XunFeiEnums.EXCEPT_INFO.NO_MATCH:
                            //returnObj.shouldResolve = false;
                            returnObj.rejectMessage = t(`${i18nKey}:NotChinese`);
                            break;
                        default:
                            returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
                            //returnObj.shouldResolve = false;
                            break;
                    }
                    //如果用户被rejected. 我们返回0分
                    internalResult.passedWordCount = 0;
                    internalResult.pronScore = 0;
                    internalResult.accuracyScore = 0;
                    internalResult.fluencyScore = 0;
                    internalResult.completionScore = 0;
                    internalResult.toneScore = 0;
                    internalResult.totalScore = 0;
                    returnObj.result = internalResult;
                    returnObj.shouldResolve = true;
                } else {
                    returnObj.result = internalResult;
                    returnObj.shouldResolve = true;
                }
            } else {
                returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
            }
        }
    } else {
        returnObj.rejectMessage = _.toString(parseError);
    }

    return returnObj;
};

const handleXunfeiResult = (internalInfoObj, xmlResult, callback) => {
    //https://www.xfyun.cn/doc/Ise/IseAPI.html
    //first see if request is success or not
    //Please Note the return obj prop is first letter upper case
    let handler = new htmlparser.DomHandler((error, xdom) => {
        const returnObj = processXunfeiDom(internalInfoObj, error, xdom);
        callback(returnObj);
    });
    const parser = new htmlparser.Parser(handler, { xmlMode: true });
    parser.write(xmlResult);
    parser.done();
};
//endregion

export { handleXunfeiResult, handleTextForXunFei };
